import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-document-last-edit-info',
    templateUrl: './last-edit-info.component.html',
    styleUrls: ['./last-edit-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LastEditInfoComponent {
    @Input() refObject: ILastEditInfo;

    constructor(
        private appTextService: AppTextService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    isShowUpdatedText() {
        return this.refObject.ChangedOn && this.refObject.ChangedOn !== this.refObject.CreatedOn;
    }

    isShowCreatedText() {
        return !this.isShowUpdatedText();
    }

    getChangedOnText() {
        const format = {};
        format['{date}'] = this.fiFormatDateService.formatDate(this.refObject.ChangedOn, 'date-time');
        return this.appTextService.get('updated_date_by', format);
    }

    getCreatedOnText() {
        const format = {};
        format['{date}'] = this.fiFormatDateService.formatDate(this.refObject.CreatedOn, 'date-time');
        return this.appTextService.get('created_date_by', format);
    }
}

export interface ILastEditInfo {
    ChangedOn;
    ChangedByUserId;
    ChangedByUserName;
    CreatedOn;
    CreatedByUserId;
    CreatedByUserName;
}
